<template>
    <div class="product-details">
        <v-dialog
            v-model="dialog"
            content-class="custom-product-dialog"
            persistent
           
            width="60%"
        >
            <div class="productContainer">
                <div class="flex imageGrid">
                    <div class="ml-8 mb-3" style=" width: 200px; ">
                        <img :src="data.images && data.images.length ? data.images[0].image.original : defaultImage" alt="" />
                    </div>

                    <div class="ml-8 " style="width:50%">
                        <p class="heading"> {{ data.product_name }} </p>
                        <div
                            class="flex"
                            style="
                                justify-content: space-between;
                                font-size: 20px;
                                align-content: flex-start;
                                width:70%
                            "
                        >
                            <p style="color: #727b76">Weight</p>
                           
                            <p > 
                                {{ data.product_size }} {{ data.measuring_unit ? data.measuring_unit.name : '' }} 
                            </p>
                        </div>
                        <div
                            class="flex"
                            style="
                                justify-content: space-between;
                                font-size: 20px;
                                align-items: flex-start;
                                width:70%
                            "
                        >
                            <p style="color: #727b76">MRP</p>
                            <p style="color: #1e6b22">&#8377; {{ data.maximum_retail_price }} </p>
                        </div>
                        <div
                            class="flex"
                            style="
                                justify-content: space-between;
                                font-size: 20px;
                                align-items: flex-start;
                                width:70%
                            "
                        >
                            <p style="color: #727b76">Availability</p>
                            <p style=""> {{ data.is_global?'Global':'Local' }} </p>
                        </div>
                    </div>
                    <v-spacer />
                    <div>
                        <button
                            class="close"
                            style="
                                background-color: #eff6f3;
                                padding: 0.6rem;
                                border-radius: 7px;
                            "
                            @click="$emit('close')"
                        >
                            <v-icon color="#1F8F58">mdi-close</v-icon>
                        </button>
                    </div>
                </div>
                <div class="mt-4 ml-8 mr-2">
                    <p style="font-size: 18px; color: #727b76">
                        Product description
                    </p>
                    <p
                        style="
                            font-size: 18px;
                            color: #445149;
                            margin-top: -0.6rem;
                        "
                    >
                        {{ data.product_description }}
                    </p>
                </div>
            </div>
        </v-dialog>
    </div>
</template>

<script>
export default {
    name: "productDetails",

    data() {
        return {
            defaultImage : require("../../../../assets/MainDashboard/Products/DefaultImage.png")
        }
    },

    props: {
        dialog : {
            type: Boolean,
        },

        data : {
            type : Object,
            required : true
        }
    },
};
</script>

<style scoped>
.productContainer {
    margin-top: 2rem;
    padding: 2rem;
   
}
.imageGrid {
    align-items: flex-start;
    justify-content: space-evenly;
    
}
.heading {
    font-size: 24px;
    color: #328636;
}
img {
    border: 1px solid rgb(224, 222, 222);
    width: 100%;
}
</style>